export function Logo({ className, children }) {
  return (
    <h1 className={className} id="logo">
      {children}
    </h1>
  );
}
